import { render, staticRenderFns } from "./DataAnalysisDashboardPivotNuovoPage.vue?vue&type=template&id=f4a4ee86"
import script from "./DataAnalysisDashboardPivotNuovoPage.vue?vue&type=script&lang=js"
export * from "./DataAnalysisDashboardPivotNuovoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports